import { useApi } from '../useApi';
import { prepareAuthHeaders } from '../requestsHelper';
import { baseUrl, ServiceName } from '../urlHelper';

import { CONSTANTS_PATH } from '../constant';
import { PaginatedResponse } from '../type/PaginatedResponse';
import { ChatRequest } from '../../type/request/ChatRequest';


export const useGetRequestListAPI = () => {
    const { apiCall } = useApi();

    const getRequestList = async (
        page: number = 0,
        size: number = 50
    ): Promise<PaginatedResponse<ChatRequest>> => {
        const url: string = `${baseUrl(ServiceName.REQUESTS)}${CONSTANTS_PATH.REQUEST_SERVICE}`;

        return await apiCall<PaginatedResponse<ChatRequest>>(url, {
            method: 'GET',
            headers: {
                ...prepareAuthHeaders(),
            },
            params: { page, size },
        });
    };

    return { getRequestList };
};
